
// 过滤ts类型验证
// @ts-nocheck
import { Vue, Options } from "vue-class-component";
import {
  fetchCode,
  postRegster,
  postInviteCode,
} from "../../api/modules/register.js";
import { showMsg } from "@utils/index.js";

@Options({
  data() {
    return {
      inviteCode: "", // 邀请码
      setCodeLeftTime: 0,
      ajaxData: {
        companyName: "",
        userName: "",
        password: "",
        phone: "",
        validCode: "",
      },
      errorData: {
        companyName: true,
        userName: true,
        password: true,
        phone: true,
        validCode: true,
      },
      timer: null,
    };
  },

  methods: {
    sendMsg() {},

    // 验证：
    checkVal(key: string) {
      let value = this.ajaxData[key];
      console.log(value);

      if (value == "") {
        this.errorData[key] = true;
      } else {
        let error = false;
        switch (key) {
          case "phone":
            let regs = /^1\d{10}$/;
            error = !regs.test(value); 
            console.log(error);
            break;
          case "password":
            error = value.length && value.length < 6;
            break;
          default:
            error = false;
        }

        this.errorData[key] = error;
      }
    },

    // 发送验证码
    sendMsgCode() {
      let that = this;
      if (that.errorData.phone) {
        return showMsg({
          text: "请输入正确手机号！",
          type: "error",
        });
      }
      that.startTimer();
      fetchCode({ phone: that.ajaxData.phone })
        .then((res) => {
          if (res.code === 200) {
            showMsg({
              text: res.message,
              type: "success",
            });
          } else {
            showMsg({
              text: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          showMsg({
            text: error.message,
            type: "error",
          });
        });
    },

    // 验证倒计时
    startTimer() {
      let that = this;
      clearInterval(that.timer);
      that.timer = null;
      that.setCodeLeftTime = 59;
      that.timer = setInterval(() => {
        if (that.setCodeLeftTime > 0) {
          that.setCodeLeftTime -= 1;
        } else {
          clearInterval(that.timer);
          that.setCodeLeftTime = 0;
        }
      }, 1000);
    },

    // 注册
    register() {
      for (let key in this.errorData) {
        if (this.errorData[key]) {
          return showMsg({
            text: "数据不完整！",
            type: "error",
          });
        }
      }
      //  注册
      postRegster({ ...this.ajaxData })
        .then((res) => {
          if (res.isSuccess) {
            showMsg({
              text: res.message,
              type: "success",
            });
          } else {
            showMsg({
              text: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          showMsg({
            text: error.message,
            type: "error",
          });
        });

      // 提交邀请
      postInviteCode({
        companyName: this.ajaxData.companyName, // 公司名
        userName: this.ajaxData.userName, // 用户名
        phone: this.ajaxData.phone, // 手机号
        inviteCode: this.inviteCode, // 邀请码
      })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
})
export default class Register extends Vue {}
